import { questionTranslatablesOptIn, questionTranslatablesName, questionTranslatablesResponseConfirmation } from "FlowBuilder/lib/questionTranslatable";

const types = {
  instruction: {
    name: 'Instruction',
    icon: SvgIconsNote,
    multiline: true,
    showRequired: false,
    dashboardDisabled: true,
  },
  text: {
    name: 'Text',
    icon: SvgIconsQuestion,
    showRequired: true,
    customFieldKind: 'string',
  },
  long_text: {
    name: 'Long text',
    icon: SvgIconsQuestion,
    showRequired: true,
    customFieldKind: 'string',
    settings: [
      { key: 'numberOfRows', label: 'Rows in height', type: 'number'}
    ]
  },
  multiple_choice: {
    name: 'Multiple choice',
    icon: SvgIconsQuestion,
    showRequired: true,
    hasAnswers: true,
    customFieldKind: 'string',
  },
  multiple_select: {
    name: 'Multiple select',
    icon: SvgIconsQuestion,
    showRequired: true,
    hasAnswers: true,
    settings: [
      { key: 'enableMaxAnswers', label: 'Limit the amount of answers selectable', type: 'checkbox_and_message' },
      { key: 'maxAnswers', label: 'Maximum answers', type: 'number_max_answers', placeholder: 'Leave blank for unlimited' },
    ]
  },
  checkbox: {
    name: 'Checkbox',
    icon: SvgIconsQuestion,
    showRequired: true,
    requiredConfigText: 'Required to be checked',
    hasAnswers: false,
    customFieldKind: 'string',
  },
  name: {
    name: 'Name',
    icon: SvgIconsQuestion,
    showRequired: true,
    defaultLabel: 'Name',
    settings: [
      { key: 'splitNames', label: 'Split first and last names', type: 'checkbox' },
      { key: 'firstNamePlaceholder', label: 'First name placeholder', type: 'text', placeholder: questionTranslatablesName.firstNamePlaceholder.default, showIf: (settings) => settings?.splitNames },
      { key: 'lastNamePlaceholder', label: 'Last name placeholder', type: 'text', placeholder: questionTranslatablesName.lastNamePlaceholder.default, showIf: (settings) => settings?.splitNames },
    ]
  },
  email: {
    name: 'Email',
    icon: SvgIconsQuestion,
    showRequired: true,
    defaultLabel: 'Email',
  },
  postcode: {
    name: 'Postcode',
    icon: SvgIconsQuestion,
    showRequired: true,
    defaultLabel: 'Postcode',
  },
  phone_number: {
    name: 'Phone number',
    icon: SvgIconsQuestion,
    showRequired: true,
    defaultLabel: 'Phone number',
  },
  opt_in_radio: {
    name: 'Opt-in radio',
    icon: SvgIconsQuestion,
    defaultRequired: true,
    settings: [
      { key: 'topics', label: 'Opt-in topics', type: 'subscription_topics_select' },
      { key: 'yesLabel', label: 'Yes label', type: 'text', placeholder: questionTranslatablesOptIn.yesLabel.default },
      { key: 'noLabel', label: 'No label', type: 'text', placeholder: questionTranslatablesOptIn.noLabel.default },
      { key: 'optOutPrompt', label: 'Prompt if someone opts out', type: 'checkbox_and_message' },
      { key: 'optOutTitle', label: 'Title', type: 'text_opt_out' },
      { key: 'optOutMessage', label: 'Message', type: 'text_opt_out' },
    ],
    dashboardDisabled: true,
  },
  score: {
    name: 'Score',
    icon: SvgIconsQuestion,
    showRequired: true,
  },
  file: {
    name: 'File upload',
    icon: SvgIconsQuestion,
    showRequired: true,
  },
  date: {
    name: 'Date',
    icon: SvgIconsQuestion,
    showRequired: true,
  },
  responses_confirmation: {
    name: 'Responses Confirmation',
    icon: SvgIconsQuestion,
    defaultLabel: 'Confirm responses',
    showRequired: false,
    settings: [
      { key: 'responseConfirmMessage', label: 'Confirm message', type: 'text', placeholder: questionTranslatablesResponseConfirmation.responseConfirmMessage.default },
      { key: 'noAnswerProvidedMessage', label: 'No answer provided message', type: 'text', placeholder: questionTranslatablesResponseConfirmation.noAnswerProvidedMessage.default },
    ],
    dashboardDisabled: true,
  }
  // ranking: {
  //   name: 'Ranking',
  //   icon: SvgIconsQuestion,
  //   showRequired: true,
  // },
}

export default types;

